import { PublicApplicationData } from '@flatsy/types/Applications'
import { parseApiDate } from '@flatsy/utils/Functions/DateTime/Date'
import { format } from '@flatsy/utils/Functions/DateTime/Datefns'
import { Collapse } from '@material-ui/core'
import { TransitionProps } from '@material-ui/core/transitions'
import React from 'react'
import { PublicBooking } from 'src/redux/slices/Booking'

export const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Collapse ref={ref} {...props} collapsedHeight="100vh" />
})

export const findBookingDate = ({
  booking,
  application,
}: {
  booking: PublicBooking | undefined
  application: PublicApplicationData | undefined
}): string | undefined => {
  if (booking) {
    return format(
      parseApiDate(`${booking.start_date}T${booking.start_time}`),
      "cccc dd MMMM à H'h'mm"
    )
  }
  if (application && application.booking_wanted_date) {
    return format(
      parseApiDate(`${application.booking_wanted_date}T${application.booking_wanted_time}`),
      "cccc dd MMMM à H'h'mm"
    )
  }

  return undefined
}
